export enum Rights {
    None = 0,
    OrganizationRead = 1,
    OrganizationCreate = 2,
    OrganizationEdit = 3,
    OrganizationDelete = 4,
    GroupAndUserRead = 11,
    GroupAndUserCreate = 12,
    GroupAndUserEdit = 13,
    GroupAndUserDelete = 14,
    RoleRead = 21,
    RoleCreate = 22,
    RoleEdit = 23,
    RoleDelete = 24,
    BoxRead = 31,
    BoxCreate = 32,
    BoxEdit = 33,
    BoxDelete = 34,
    CustomerRead = 41,
    CustomerCreate = 42,
    CustomerEdit = 43,
    CustomerDelete = 44,
    ArticleRead = 51,
    ArticleCreate = 52,
    ArticleEdit = 53,
    ArticleDelete = 54,
    AttributRead = 61,
    AttributCreate = 62,
    AttributEdit = 63,
    AttributDelete = 64,
    DocumentTypeRead = 71,
    DocumentTypeCreate = 72,
    DocumentTypeEdit = 73,
    DocumentTypeDelete = 74,
    FolderStateRead = 81,
    FolderStateCreate = 82,
    FolderStateEdit = 83,
    FolderStateDelete = 84,
    ProcessRead = 91,
    ProcessCreate = 92,
    ProcessEdit = 93,
    ProcessDelete = 94,
    ParameterRead = 101,
    ParameterCreate = 102,
    ParameterEdit = 103,
    ParameterDelete = 104,
    EmailTemplateRead = 121,
    EmailTemplateCreate = 122,
    EmailTemplateEdit = 123,
    EmailTemplateDelete = 124,
    WorkflowDefinitionRead = 131,
    WorkflowDefinitionCreate = 132,
    WorkflowDefinitionEdit = 133,
    WorkflowDefinitionDelete = 134,
    ListLayoutRead = 141,
    ListLayoutCreate = 142,
    ListLayoutEdit = 143,
    ListLayoutDelete = 144,
    StatesSetRead = 151,
    StatesSetCreate = 152,
    StatesSetEdit = 153,
    StatesSetDelete = 154,
    ViewRead = 161,
    ViewCreate = 162,
    ViewEdit = 163,
    ViewDelete = 164,

    EmailAddressRead = 171,
    EmailAddressCreate = 172,
    EmailAddressEdit = 173,
    EmailAddressDelete = 174,
    ModifyUserRoles = 183,
    ChildOrganizationAdministration = 184,
    Archiving = 185,
    CustomizeFolderTracking = 186,
    SubscriptionRead = 191,
    SubscriptionEdit = 193,
    ApiConfigurationRead = 201,
    ApiConfigurationCreate = 202,
    ApiConfigurationEdit = 203,
    ApiConfigurationDelete = 204,
    SmsTemplateRead = 211,
    SmsTemplateCreate = 212,
    SmsTemplateEdit = 213,
    SmsTemplateDelete = 214,

    ProfileEdit = 503,

    LogSupervision = 601,
    StorageRead = 611,
    StorageDelete = 614,

    FolderRead = 1001,
    FolderCreate = 1002,
    FolderEdit = 1003,
    FolderDelete = 1004,
    toggleReadState = 1005,

    BoxView = 1010,
    WorkflowView = 1011,
    View = 1012,

    ArchiveRead = 1021,
    ArchiveCreate = 1022,

    MoveFolderToBox = 1031,
    MergeFolder = 1032,
    AddFileToFolder = 1033,
    SendEmail = 1035,
    ChangeStandByState = 1036,
    DuplicateFolder = 1037,
    SendSms = 1038,
    ContactRead = 1041,
    ContactCreate = 1042,
    ContactEdit = 1043,
    ContactDelete = 1044,
    ReminderRead = 1051,
    ReminderCreate = 1052,
    ReminderEdit = 1053,
    ReminderDelete = 1054,
    ReminderNotificationRead = 1061,
    ReminderNotificationCreate = 1062,
    ReminderNotificationEdit = 1063,
    ReminderNotificationDelete = 1064,
    WorkflowStepActivation = 1075,
    WorkflowStepCompletion = 1076,
    Supervision = 1081,
    UnlockFolder = 1091,
    ExportFolders = 1101,
    AddComment = 1201,
    UpdateComment = 1202,
    DeleteComment = 1203,
    ViewCommentHistory = 1204,
    DocumentDelete = 1211,
    ManagePredefinedFilters = 1221,
    DraftEmailRead = 1231,
    DraftEmailWrite = 1232,
    FollowFolder = 1241,
}
